import { render } from "./wContentBanner.vue?vue&type=template&id=7a239326&scoped=true"
import script from "./wContentBanner.vue?vue&type=script&lang=js"
export * from "./wContentBanner.vue?vue&type=script&lang=js"

import "./wContentBanner.vue?vue&type=style&index=0&id=7a239326&scoped=true&lang=scss"

import exportComponent from "/Users/jade/Documents/D1m/website-urlscheme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a239326"]])

export default __exports__